import { handleActions } from 'redux-actions';
import { ProfileHero } from '../../types/profileHero';
import {
  setIsRepositioning,
  setSelectedDeviation,
} from '../actions/profileHero';

export default handleActions<ProfileHero, any>(
  {
    [setIsRepositioning.toString()]: (
      state: ProfileHero,
      action: ReturnType<typeof setIsRepositioning>
    ): ProfileHero => ({
      ...state,
      isRepositioning: !!action.payload,
    }),
    [setSelectedDeviation.toString()]: (
      state: ProfileHero,
      action: ReturnType<typeof setSelectedDeviation>
    ): ProfileHero => ({
      ...state,
      selectedCoverDeviation: action.payload,
    }),
  },
  {
    isRepositioning: false,
    selectedCoverDeviation: null,
  }
);
